import React from "react";

export const RootContext = React.createContext();
export const RootDispatchContext = React.createContext();

function RootProvider({children}) {
    const [state,setstate] = React.useState("/home");
    return(
        <RootContext.Provider value={state}>
            <RootDispatchContext.Provider value={setstate} >
                {children}
            </RootDispatchContext.Provider>
        </RootContext.Provider>
    )
}

export {RootProvider};
